export default (message, type = 'ApplicationError', name = 'ApplicationError', cause = 'ApplicationError', stack = null) => ({ message, cause, name, stack, type })
